import {Service} from './service.class';
import M = Service.InjectedMembers;

/**
 * Created by Rodrigo Quesada on 09/12/16.
 */
export abstract class SectionService extends Service {

    constructor(svcm: M, namespace: string) {
        super(svcm, `section/${namespace}`);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/section-service.class.ts